
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payment-success",
      function () {
        return require("private-next-pages/payment-success/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payment-success"])
      });
    }
  